module.exports = __webpack_public_path__ + "assetsclientes/img/card-basic-person.dea304d8.png";